import { parse } from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { Page } from '../../../../helbest';
import { Drawer, ProductItem } from '../../../components';
import useCategoryBar from '../../../components/CategoryBar/useCategoryBar';
import Content from '../../../components/Home/Content/Content';
import useCategoy from '../useCategory';
import CategoryBar from './CategoryBar/CategoryBar';

export const getSortedParams = (params) =>
  [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null
  ].filter((catItem) => catItem !== null);

const MainCategory = ({ Login }) => {
  const { layouts, list } = useCategoy(Login);
  const { categories, activeCategory, setActiveCategory } = useCategoryBar();
  const params = useParams();
  const location = useLocation();
  const queryParams = parse(location.search);
  const paramsArray = getSortedParams(params);
  const has_homepage = categories?.find(
    (citem) => Number(citem.id) === Number(activeCategory)
  ).has_homepage;

  return (
    <Page cart className="page-category" drawer={<Drawer />} hasHeader logo showFooter>
      <CategoryBar
        activeCategory={activeCategory}
        categories={categories}
        setActiveCategory={setActiveCategory}
        showCatg={true}
        withoutUrl={true}
      />
      <div className="page-category-product-container">
        {paramsArray[paramsArray.length - 1] === paramsArray[paramsArray.length - 2] ? (
          <>
            <Content className="pad-0" layouts={layouts} />
            {list?.map((data, i) => (
              <React.Fragment key={`${activeCategory}-${i}`}>
                <ProductItem
                  key={i}
                  data={data}
                  id={params.id}
                  productDetailId={Number(queryParams.product_id) === Number(data.product_id)}
                />
              </React.Fragment>
            ))}
          </>
        ) : has_homepage ? (
          <Content className="pad-0" layouts={layouts} />
        ) : (
          <>
            <Content className="pad-0" layouts={layouts} />
            {list?.map((data, i) => (
              <React.Fragment key={`${activeCategory}-${i}`}>
                <ProductItem
                  key={i}
                  data={data}
                  id={params.id}
                  productDetailId={Number(queryParams.product_id) === Number(data.product_id)}
                />
              </React.Fragment>
            ))}
          </>
        )}
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

export default connect(mapStateToProps)(MainCategory);
